import { Directive, ElementRef, Input } from '@angular/core';
import { fromEvent } from 'rxjs';
import { delay, withLatestFrom } from 'rxjs/operators';
import { ISettings } from 'src/app/core/interfaces';
import { SettingsService } from 'src/app/services/settings/settings.service';
import { ReadingService } from 'src/app/services/text/reading.service';

@Directive({
    selector: '[asgReadAloud]',
    standalone: true
})
export class ReadAloudDirective {
  @Input() asgReadAloud: string | undefined;

  constructor(
    private readonly el: ElementRef,
    private readonly settingsService: SettingsService,
    private readonly readingService: ReadingService,
  ) {
    this.init();
  }

  private init(): void {
    const onHoverEventObservable = fromEvent(this.el.nativeElement, 'pointerover').pipe(delay(200));
    
    onHoverEventObservable.pipe(withLatestFrom(this.settingsService.getSettingsObservable()))
      .subscribe(([event, settings]: [PointerEvent, ISettings]) => {
        if (!settings.readMenuItems) {
          return;
        }

        const text = (event.target as HTMLElement).innerText;
        const voice = this.asgReadAloud ?? settings.UIVoice;

        if (!!text && !!voice) {
          this.readingService.readMenuItem(text, voice);
        }
      });
  }
}
